module.exports = "/_next/static/images/AWSPune-f155a28d78edc45587a387f75b42b5cd.jpg";